import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=8a3ae056&"
import script from "./radio.vue?vue&type=script&lang=js&"
export * from "./radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports